import { render, staticRenderFns } from "./InstrumentManagement.vue?vue&type=template&id=2e235c06&"
import script from "./InstrumentManagement.vue?vue&type=script&lang=ts&"
export * from "./InstrumentManagement.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentManagement.vue?vue&type=style&index=0&id=2e235c06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports